export default __webpack_public_path__ + "static/media/kia.8c45ddac.webp";